import { useTranslation, Trans } from 'next-i18next';
import { FC } from 'react';
import Tooltip, { DefaultCTA as TooltipCTA } from 'src/common/components/Tooltip';
import UniversalLink from 'src/common/components/UniversalLink';
import styles from './TermsAndCancellation.module.scss';

type Props = {
  cancellationPolicy?: string;
  listingUrl: string;
  freeCancellationInMarketplace?: boolean;
};

const TermsAndCancellation: FC<Props> = ({
  cancellationPolicy,
  listingUrl,
  freeCancellationInMarketplace,
}) => {
  const [t] = useTranslation('common');

  if (!cancellationPolicy) {
    return null;
  }

  let description = t('pricing--terms-and-cancellation-policy-description');

  if (freeCancellationInMarketplace) {
    description = cancellationPolicy;
  }

  return (
    <div className={styles.root}>
      <p className={styles.label}>{t('pricing--terms-and-cancellation-policy-label')}</p>
      <p className={styles.description}>
        {description}
      </p>
      {!freeCancellationInMarketplace && (
        <Tooltip
          renderCTA={(props) => (
            <TooltipCTA {...props}>
              <span className={styles.policy}>
                {cancellationPolicy}
              </span>
            </TooltipCTA>
          )}
        >
          <p className={styles.tooltipInfo}>
            <Trans
              t={t}
              i18nKey="pricing--terms-cancellation-policy-tooltip"
              components={[<UniversalLink
                className={styles.listingLink}
                href={listingUrl}
                openInNewTab
              />,
              ]}
            />
          </p>
        </Tooltip>
      )}
    </div>
  );
};

export default TermsAndCancellation;
